const SESSION_KEY = 'oneview_impersonation_session'

export interface ImpersonationSession {
  targetUpn: string
  targetName: string
  adminUpn: string
  adminName: string
  sessionId: string
  reason: string
  startTime: string
  expiresAt: string
}

export function getSession(): ImpersonationSession | null {
  try {
    const raw = sessionStorage.getItem(SESSION_KEY)
    if (!raw) return null

    const session: ImpersonationSession = JSON.parse(raw)

    if (new Date(session.expiresAt) < new Date()) {
      endImpersonation()
      return null
    }

    return session
  } catch {
    sessionStorage.removeItem(SESSION_KEY)
    return null
  }
}

export function getImpersonationUpn(): string | null {
  return getSession()?.targetUpn ?? null
}

export function isImpersonating(): boolean {
  return getSession() !== null
}

export function startImpersonation(opts: {
  targetUpn: string
  targetName: string
  adminUpn: string
  adminName: string
  reason?: string
  durationMinutes?: number
}): ImpersonationSession {
  const now = new Date()
  const duration = opts.durationMinutes ?? 60
  const expires = new Date(now.getTime() + duration * 60_000)

  const session: ImpersonationSession = {
    targetUpn: opts.targetUpn,
    targetName: opts.targetName,
    adminUpn: opts.adminUpn,
    adminName: opts.adminName,
    reason: opts.reason ?? '',
    sessionId: crypto.randomUUID(),
    startTime: now.toISOString(),
    expiresAt: expires.toISOString(),
  }

  sessionStorage.setItem(SESSION_KEY, JSON.stringify(session))
  window.dispatchEvent(new CustomEvent('impersonationChanged', { detail: session }))

  return session
}

export function endImpersonation(): void {
  sessionStorage.removeItem(SESSION_KEY)
  window.dispatchEvent(new CustomEvent('impersonationChanged', { detail: null }))
}
